module.exports = __webpack_public_path__ + "static/img/aircraft.1a77dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/aircraft.png
// module id = 5otL
// module chunks = 1